import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist py-12 lg:py-20" aria-labelledby="faq-title" data-id="element-263" data-mp="x53ex5bncddd">
      <div className="mx-auto max-w-3xl px-5" data-id="element-264" data-mp="123ofx6yq312v">
        <h2 id="faq-title" className="text-center font-display text-3xl font-extrabold leading-tight tracking-tight text-ink sm:text-[42px]" data-id="element-265" data-mp="124g7m6p78env">
          Preguntas frecuentes
        </h2>
        <ul className="mt-10 space-y-3" data-id="element-266" data-mp="1utddtbg4yl09">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={f.question} className="overflow-hidden rounded-2xl bg-white ring-1 ring-brand-100" data-id="element-267" data-mp="1l0fu51zeqq02" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:bg-brand-50" data-id="element-268" data-mp="28qa67hbwkaj9">
                  <span className="font-display text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-269" data-mp="2jre2t2hu5qim">{f.question}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand-600 text-white' : 'bg-brand-50 text-brand-600'}`} data-id="element-270" data-mp="2yga84rsicpfj">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="37evqalu2i2fs" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-272" data-mp="32jzxvkkx5d25">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-273" data-mp="3hee4smr7kw0g">
                      <p className="whitespace-pre-line px-5 pb-5 leading-relaxed text-ink-soft" data-id="element-274" data-mp="27s0j265xw34z">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}